import { Component, Inject, Input, OnInit, Optional } from '@angular/core';
import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from '@angular/material/dialog';
import { AppGenFormbuilderService } from '../service/app-gen-formbuilder.service';

@Component({
  selector: 'app-advanced-rule-screen',
  templateUrl: './advanced-rule-screen.component.html',
  styleUrls: ['./advanced-rule-screen.component.scss'],
})
export class AdvancedRuleScreenComponent implements OnInit {
  appId;
  ruleDate;
  isEditable;
  editRule: null;
  createRule: boolean;
  edit: boolean = false;
  tableOffset: number;
  viewMode: boolean = false;
  isGroup = false;
  isGroupEdit = false;
  ruleEngVersionValue = 1;

  constructor(
    public dialogRef: MatDialogRef<AdvancedRuleScreenComponent>,
    public formbuilderService: AppGenFormbuilderService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.isEditable = true;
  }

  ngOnInit(): void {
    this.appId = this.formbuilderService.appId
    console.log(this)
  }

  removeCreateRule(): void {
    this.createRule = false;
    this.editRule = null;
    this.edit = false;
    this.refreshData(false);
    this.tableOffset = 0;
  }
  refreshData(arg0: boolean) {
    throw new Error('Method not implemented.');
  }
}
